import Skeleton from '@mui/material/Skeleton';
import CircularProgress from '@mui/material/CircularProgress';
import InfoLabel from './InfoLabel';
import ButtonComponent from './ButtonComponent';
import InfoIcon from './InfoIcon.jsx'; 

const MasterCompanyLevelDisplay = ({ values, config, entitled, onClick=()=>{return}, isLoading=false }) => {
    return (
        <>
            {!isLoading && Object.keys(config).length > 0 ? 
            <div className="d-flex p-3 align-items-center justify-content-between">
                <div className="d-flex flex-row gap-3 align-items-center justify-content-start" style={{flexWrap:'wrap'}}>      
                    { config.map((el,index) => 
                    <>
                        { el['columnid'] != 'consortiumid' ?
                            <div className="d-flex align-items-center gap-3">
                                {/* show info according to config */}
                                <InfoLabel title={el['columntag']+ ': '} content={values[el['columnname']]} />
                                {/* optionally show info icon based on format key */}
                                {el.format === 'info' ? <InfoIcon infoLabel={values[el['columnname']]}/> : <></>}
                                {/* show line for formatting if not last element */}
                                {index!==(Object.keys(config).length-1) && <div class="vr"></div>}
                            </div>
                        :<></> }
                    </>
                    )} 
                </div>
                <div>
                    {entitled && <ButtonComponent tag='Edit' onButtonClick={onClick}  border={'#3D3D3D 1px solid'} background={'#fff'} color={'#001317'}/>}                  
                    {/* <EntitledButton entitledBool={true} tag='Edit' cssClass='summary-page-button-80' onClick={onClick}/> */}
                </div>
            </div>
            : isLoading ? 
            <div className="d-flex flex-row gap-3 p-3 align-items-center justify-content-between">
                    <div className="w-100">
                        <Skeleton variant="rectangular" width='100%' height={'40px'} sx={{ borderRadius: '5px' }}/>
                    </div>
                    <div className="w-100">
                        <Skeleton variant="rectangular" width='100%' height={'40px'} sx={{ borderRadius: '5px' }}/>
                    </div>
                    <div className="w-100">
                        <Skeleton variant="rectangular" width='100%' height={'40px'} sx={{ borderRadius: '5px' }}/>
                    </div>
                    {entitled && <ButtonComponent tag={<CircularProgress size={'20px'} sx={{color:'black'}}/>} border={'#3D3D3D 1px solid'} background={'#fff'} color={'#001317'} width='96px'/>}  
            </div>  
            : <></>}  
        </>
    ); 
}

export default MasterCompanyLevelDisplay